import axios from 'axios'
import {store} from '../store/store'

export function getAxiosInstance() {
  return axios.create({headers: {'Authorization': 'Bearer ' + store.getters.apiKey}})
}

// Allows to get the response details associated with the error instead of 'Request failed with status xxx' or 'Internal Server error'
export function rethrowErrorWithMessage(err) {
  console.log(err)
  console.log(JSON.parse(JSON.stringify(err)))
  if (err.response) {
    throw new Error(`Error Code ${err.response.status} ${err.response.data.message}`)
  } else {
    throw err
  }
}
